import {createRouter, createWebHistory} from 'vue-router'
import LandingPageResolver from '../views/LandingPage/LandingPageResolver.vue'
import ErrorPage from "@/views/ErrorPage.vue";
import ThankYouPageResolver from "@/views/ThankYouPage/ThankYouPageResolver.vue";

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingPageResolver
  },
  {
    path: '/moving',
    name: 'LandingMoving',
    component: LandingPageResolver
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYouPageResolver
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
